module.exports = __webpack_public_path__ + "img/illust-07.709a3815.png";